import { BusEvent } from 'app/common/eventbus/Events';

type EventCallback<E> = (event: E) => void;

/**
 * Simple EventBus implementation
 * Name of Event classes are used as a key and must be unique.
 * @author mjacques
 */
export default class EventBus {
    private subscribers = new Map<string, Array<EventCallback<any>>>();

    register<E extends BusEvent>(eventName: string, callback: EventCallback<E>) {
        if (!this.subscribers.has(eventName)) this.subscribers.set(eventName, []);
        this.subscribers.get(eventName).push(callback);
    }

    unregister<E extends BusEvent>(eventName: string, callback?: EventCallback<E>) {
        const callbacks = this.subscribers.get(eventName);
        if (!callbacks) return;

        const index = callbacks.indexOf(callback);
        if (index !== -1) {
            callbacks.splice(index, 1);
            console.debug('Callback removed');
        }

        // Optionally clean up the map if there are no more subscribers
        if (callbacks.length === 0) {
            this.subscribers.delete(eventName);
        }
    }

    publish<E extends BusEvent>(event: E) {
        if (event) {
            const eventTypeName = event.eventName;

            if (this.subscribers.has(eventTypeName)) {
                this.subscribers.get(eventTypeName).forEach(callback => {
                    callback(event);
                });
            }
        }
    }
}
